import { createRangeTagManager } from '../../utils/createRangeTagManager';

export const floorTagManager = createRangeTagManager({
  jsonQueryKey: 'floor',
  template: 'Этаж %s',
  id: 'floor',
});
